import { render, staticRenderFns } from "./MIS.vue?vue&type=template&id=03a106a4&"
import script from "./MIS.vue?vue&type=script&lang=js&"
export * from "./MIS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports